import { WrapperWithScroll } from '@/common/styles/Wrappers';
import Loading from '../../../common/components/Loading';
import PaymentData from './components/paymentData/PaymentData';
import SearchBar from './components/searchBar/SearchBar';
import useCCPayment from './hooks/useCCPayment';

const CCPayment = () => {
	const hook = useCCPayment();

	return (
		<WrapperWithScroll>
			{hook.isLoading && <Loading />}

			<SearchBar hook={hook} />

			{hook.paymentData?.length > 0 &&
				hook.selectedConsultant &&
				hook.paymentData
					.sort((a, b) => a._id.localeCompare(b._id))
					.map(
						(consultantResults, i) =>
							hook.selectedConsultant
								.map((consultant) => consultant.value)
								.includes(consultantResults._id) && (
								<PaymentData
									key={i}
									consultantResults={consultantResults}
									paymentData={hook.paymentData}
									reloadData={hook.reloadData}
									forexRates={hook.forexRates}
								/>
							),
					)}
		</WrapperWithScroll>
	);
};

export default CCPayment;
